import { Layout as AntLayout } from "antd"
import { Footer } from "../Footer"
import { Header } from "../Header"

type Props = {
  children: React.ReactNode
}

const { Content } = AntLayout

export const Layout: React.FC<Props> = ({ children }) => (
  <AntLayout
    style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
  >
    <Header />
    <Content style={{ flex: 1 }}>{children}</Content>
    <Footer />
  </AntLayout>
)
